<script setup lang="ts">
import { TgWappenSvg } from '@/helpers/images'
import { useGlobals } from '@/helpers/globals'

withDefaults(
    defineProps<{
        app: boolean
        small?: boolean
    }>(),
    {
        app: false,
        small: false,
    },
)

const env = useGlobals().config?.env
</script>

<template>
    <v-app-bar :app="app" class="kp-header" :class="env ? env : ''">
        <img :src="TgWappenSvg" height="45" alt="Thurgau Wappen" style="margin-right: 5px" />
        <div>
            <h1 class="title">
                {{ $t('g_efp') }}
            </h1>
            <div class="subtitle">
                {{ $t('k_tg_sh') }}
            </div>
        </div>
    </v-app-bar>
</template>
